export const zhCNAgentGuiAddContent = {
  addContentResourcePanel: "资源面板",
  addContentConnectors: "连接器",
  addContentConnectorConnected: "已授权",
  addContentConnectorSelected: "已选中",
  addContentConnectorConnect: "安装",
  addContentConnectorAuthorize: "授权",
  addContentConnectorEmpty: "暂无连接器",
  addContentConnectorMore: "查看更多连接器",
  composerFileStillPreparing: "附件还在准备中，完成后才能打开。",
  composerFileOpenFailed: "这个附件准备失败了，请删除后重新添加。",
  composerFileOpenUnavailable: "这个附件还没有可打开的路径，请删除后重新添加。"
} as const;
